import { ColumnDef } from '@tanstack/react-table'
import { TableColumnHeader } from '@/components/data-table/table-column-header'
import { IUserColumn } from '../_data/user-interface'
import { UserTableAction } from './users-table-action'
import UserStatus from './user-status'
import { format } from 'date-fns'
import TruncateText from '@/components/truncate-text'
import UsersRoleTooltip from './users-role-tooltip'
import UsersRoleTooltipMobile from './users-role-tooltip-mobile'

export const UserTableColumn: ColumnDef<IUserColumn>[] = [
  {
    accessorKey: 'firstName',
    enableSorting: false,
    header: ({ column }) => (
      <TableColumnHeader column={column} title={'First Name'} />
    ),
    cell: ({ row }) => <TruncateText text={row.getValue('firstName')} />,
  },
  {
    accessorKey: 'lastName',
    enableSorting: false,
    header: ({ column }) => (
      <TableColumnHeader column={column} title={'Last Name'} />
    ),
    cell: ({ row }) => <TruncateText text={row.getValue('lastName')} />,
  },
  {
    accessorKey: 'email',
    enableSorting: false,
    header: ({ column }) => (
      <TableColumnHeader column={column} title={'Email'} />
    ),
    cell: ({ row }) => <TruncateText text={row.getValue('email')} />,
  },
  {
    accessorKey: 'lastestLogin',
    enableSorting: false,
    header: ({ column }) => (
      <TableColumnHeader column={column} title={'Last Login'} />
    ),
    cell: ({ row }) => {
      const value = row.original.lastestLogin
      return !value ? (
        <p>-</p>
      ) : (
        <div>{format(value, 'MMM do, yyyy h:mmaaa')}</div>
      )
    },
  },
  {
    accessorKey: 'role',
    enableSorting: false,
    header: ({ column }) => (
      <TableColumnHeader
        column={column}
        title={'Role'}
        customHeader={
          <>
            <div className="md:block hidden">
              <UsersRoleTooltip />
            </div>
            <div className="md:hidden">
              <UsersRoleTooltipMobile />
            </div>
          </>
        }
      />
    ),
    cell: ({ row }) => {
      const role = row.original.role
      return <div>{role.title}</div>
    },
  },

  {
    accessorKey: 'status',
    enableSorting: false,
    header: ({ column }) => (
      <TableColumnHeader
        className=" justify-center flex"
        column={column}
        title={'Status'}
      />
    ),
    cell: ({ row }) => {
      const status = row.original.status
      return (
        <div className="text-center flex items-center justify-center">
          <UserStatus {...status} />
        </div>
      )
    },
  },
  {
    id: 'actions',
    header: ({ column }) => (
      <TableColumnHeader
        column={column}
        title={'Action'}
        className="item-center flex justify-center"
      />
    ),
    enableSorting: false,
    cell: ({ row }) => <UserTableAction row={row} />,
  },
]
